/* eslint-disable no-param-reassign */
export function removeIllegalCharacters(ev, pattern) {
  // We need to add the global flag for the pattern to work
  const regex = new RegExp(`${pattern}`, 'g');
  const matched = ev.target.value.match(regex)?.find(el => el) ?? '';
  ev.target.value = matched;
}

export function removeWhiteSpace(ev) {
  ev.target.value = ev.target.value.replaceAll(' ', '');
}

export function removeNonAlphaNumericCharacters(ev) {
  ev.target.value = ev.target.value.replaceAll(/[^a-zA-Z0-9]/g, '');
}
